// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__5RkoU","cell":"ColumnAccessor_cell__WrIU-","firstCellAccent":"ColumnAccessor_firstCellAccent__SJya2"};